/* tslint:disable */
/* eslint-disable */
/**
 * Melco Eod APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EodMelcoEodModelsScanResponse
 */
export interface EodMelcoEodModelsScanResponse {
    /**
     * 
     * @type {string}
     * @memberof EodMelcoEodModelsScanResponse
     */
    url?: string | null;
}

export function EodMelcoEodModelsScanResponseFromJSON(json: any): EodMelcoEodModelsScanResponse {
    return EodMelcoEodModelsScanResponseFromJSONTyped(json, false);
}

export function EodMelcoEodModelsScanResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EodMelcoEodModelsScanResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}

export function EodMelcoEodModelsScanResponseToJSON(value?: EodMelcoEodModelsScanResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
    };
}


